'use strict';

let scrollStartedY = 0;
let scrollCurrentY = 0;
let scrollDelta = 0;
let isScrollingUp = false;
let isMouseWheel = false;
let isTouch = false;
let isTicking = false;

const bodyEl = document.querySelector('body');
const navEl = document.querySelector('.js-header');
const navActionsEl = document.querySelector('.js-header-actions');
const navVisibleBodyClass = 'nav-visible';
const navHiddenBodyClass = 'nav-hidden';
const hideCssClass = 'nav-hide';
const hideThresholdScroll = 10;
const hideThresholdTouch = 15;

const animateNav = () => {
    const hasHideClass = navEl.classList.contains(hideCssClass);
    const hasSearchExpanded = navActionsEl.classList.contains('search-expand');
    const hideThreshold = isTouch ? hideThresholdTouch : hideThresholdScroll;
    const isOverThreshold = scrollDelta > hideThreshold;
    const bodyStyle = window.getComputedStyle(bodyEl);
    const isWindowScrolledToTop = document.documentElement.scrollTop === 0;

    // Check if the overflow property of body is set to hidden
    const overflowHidden = bodyStyle.overflow === 'hidden';

    if (isScrollingUp && hasHideClass && isOverThreshold && !overflowHidden) {
        bodyEl.classList.remove(navHiddenBodyClass);
        bodyEl.classList.add(navVisibleBodyClass);
        navEl.classList.remove(hideCssClass);
    }

    if (!isScrollingUp && !hasHideClass && isOverThreshold && !hasSearchExpanded && !overflowHidden) {
        bodyEl.classList.remove(navVisibleBodyClass);
        bodyEl.classList.add(navHiddenBodyClass);
        navEl.classList.add(hideCssClass);
    }

    if (isScrollingUp && isWindowScrolledToTop && hasHideClass) {
        bodyEl.classList.remove(navHiddenBodyClass);
        bodyEl.classList.add(navVisibleBodyClass);
        navEl.classList.remove(hideCssClass);
    }
};

function mobileCheckOnLongScroll() {
    if (document.documentElement.scrollTop === 0) {
        setTimeout(function(){
            bodyEl.classList.remove(navHiddenBodyClass);
            bodyEl.classList.add(navVisibleBodyClass);
            navEl.classList.remove(hideCssClass);
        }, 250);
    }
}

const onMouseDown = () => {
    isMouseWheel = false;
    scrollStartedY = window.scrollY;
};

const onScroll = () => {
    if (!isMouseWheel) {
        isScrollingUp = window.scrollY < scrollCurrentY;
        scrollDelta = Math.abs(scrollStartedY - window.scrollY);
        scrollCurrentY = window.scrollY;

        if (!isTicking) {
            window.requestAnimationFrame(() => {
                animateNav(scrollDelta, isScrollingUp);
                isTicking = false;
            });

            isTicking = true;
        }
    }
};

const onWheel = (e) => {
    isMouseWheel = true;
    isScrollingUp = e.wheelDelta > 0;
    scrollDelta = Math.abs(e.wheelDelta);
    animateNav(scrollDelta, isScrollingUp);
};

const onTouchStart = () => {
    isTouch = true;
    onMouseDown();
};

const onTouchEnd = () => {
    isTouch = false;
};

const debounce = (func, delay) => {
    let timer;
    return function () {
        clearTimeout(timer);
        timer = setTimeout(func, delay);
    };
};

const debouncedOnScroll = debounce(onScroll, 50);

const initScroll = () => {
    if (navEl && navActionsEl) {
        document.addEventListener('touchstart', onTouchStart);
        document.addEventListener('touchend', onTouchEnd);
        document.addEventListener('touchmove', debouncedOnScroll);
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('scroll', () => {
            debouncedOnScroll();
            mobileCheckOnLongScroll();
        });
        document.addEventListener('wheel', onWheel);
    }
};

const navigationScroller = {
    init: () => {
        initScroll();
    }
};

module.exports = navigationScroller;
